import React from 'react';
import { HeroSection } from './components/HeroSection';
import { FeaturesSection } from './components/FeaturesSection';
import { TrustSection } from './components/TrustSection';
export function App() {
  return <main className="min-h-screen bg-black" data-id="element-0">
      <HeroSection data-id="element-1" />
      <FeaturesSection data-id="element-2" />
      <TrustSection data-id="element-3" />
    </main>;
}